import React from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { getBoundActions } from 'actions'
import { Map } from 'immutable'
import { H5 } from 'components/Heading'
import Button, { TYPES } from 'components/Button'

const MyLibraryPlaylistDeleteModal = (props) => {
  const {
    staticText,
    dismissModal,
    playlistName,
    playlistSize,
    playlistType,
    onDeleteSubmit,
  } = props

  return (
    <div className="my-library__playlist-delete-modal">
      <H5 className="my-library__playlist-delete-modal-title">
        {staticText.get('deletePlaylist')}
      </H5>
      <div className="my-library__playlist-delete-modal-text">
        {staticText.get('deletePlaylistText1')}
        <b>{` ${playlistName} `}</b>
        {staticText.get('deletePlaylistText2')}
        <b>{` ${playlistSize} `}</b>
        {staticText.get('deletePlaylistText3')}
      </div>
      <div className="my-library__playlist-delete-modal-buttons">
        <Button
          type={TYPES.SECONDARY}
          onClick={() => dismissModal()}
          stacked
        >
          {staticText.get('cancelButtonText')}
        </Button>
        <Button
          type={TYPES.PRIMARY}
          onClick={() => onDeleteSubmit(playlistType)}
          stacked
        >
          {staticText.get('deleteButtonText')}
        </Button>
      </div>
    </div>
  )
}

MyLibraryPlaylistDeleteModal.propTypes = {
  playlistName: PropTypes.string.isRequired,
  playlistSize: PropTypes.number.isRequired,
  playlistType: PropTypes.string.isRequired,
  onDeleteSubmit: PropTypes.func.isRequired,
  staticText: ImmutablePropTypes.map.isRequired,
  dismissModal: PropTypes.func.isRequired,
}

export default connect(
  (state) => {
    return {
      staticText: state.staticText.getIn(['data', 'myLibraryPage', 'data'], Map()) || Map(),
    }
  },
  (dispatch) => {
    const actions = getBoundActions(dispatch)
    return {
      dismissModal: actions.dialog.dismissModal,
    }
  },
)(MyLibraryPlaylistDeleteModal)
